module.exports = __webpack_public_path__ + "static/media/12.d0aae1b9.jpeg";